import { render } from "./FavoriteBinance.vue?vue&type=template&id=1b7b05ff"
import script from "./FavoriteBinance.vue?vue&type=script&lang=js"
export * from "./FavoriteBinance.vue?vue&type=script&lang=js"

import "./FavoriteBinance.vue?vue&type=style&index=0&id=1b7b05ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__